var Header = require('./Header');
var React = require('react');
var FileSaver = require('file-saver');
var SkipButton = require('./SkipButton');
var MetaData = require('./MetaData');
var TableOfContents = require('./TableOfContentsContainer');
var DownloadDialog = require('../../download/components/DownloadDialogContainer');
var Progress = require('./Progress');
var Tooltip = require('../../../components/Tooltip');
var scrollTo = require('../../../helpers/scrollTo');

require('./Main.css');

class Main extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            className: props.isClientSide ? 'reader' : 'pubr-reader pubr-reader--mounted',
        }
        this.handleTermClick = this.handleTermClick.bind(this);
        this.handleEscKey = this.handleEscKey.bind(this);
        this.trapFocus = this.trapFocus.bind(this);
        this.tooltip = React.createRef();
        this.firstFocus = React.createRef();
        this.skipFocusTrap = false;
    }

    componentDidUpdate() {
        if (this.props.reader.readyState === 'loaded') {
            setTimeout(() => {
                this.setState({
                    className: 'pubr-reader pubr-reader--mounted'
                })

                if (window && window.location.hash) {
                    var element = document.getElementById(window.location.hash.substring(1, window.location.hash.length))
                    scrollTo(element.offsetTop - 100, 2000)
                }

                // Epic hack to use jquery in react.
                var $ = window.$;
                $(function () {
                    $('.pubr-main .fact-block--expandable .fact-block__heading').click(function () {
                        var $heading = $(this);
                        var $body = $heading.next('.fact-block__body');
                        if ($heading.hasClass('fact-block__heading--detracted')) {
                            $heading.removeClass('fact-block__heading--detracted');
                            $heading.addClass('fact-block__heading--expanded');
                            $body.show();
                        } else {
                            $heading.removeClass('fact-block__heading--expanded');
                            $heading.addClass('fact-block__heading--detracted');
                            $body.hide();
                        }
                    });
                });
            }, 100);

            var sections = this.props.reader.sections.map((item) => {
                return {
                    ...item,
                    position: (document.getElementById(item.sectionId).offsetTop / document.querySelector('.pubr-main').scrollHeight) * 100
                }
            });

            this.props.setHeadingPositions(sections);
            this.firstFocus.current.focus();
        }
    }

    componentWillMount() {
        if (typeof (document) !== 'undefined') {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            this.props.setScrollPosition(scrollTop);
            window.scrollTo(0, 0);
            document.getElementById('body').setAttribute('style', `transform:translateY(-${scrollTop}px)`);

            document.addEventListener('keyup', this.handleEscKey);

            document.addEventListener('focus', this.trapFocus, true);
        }
        else {
            this.props.setScrollPosition(0);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.handleEscKey);
        document.removeEventListener('focus', this.trapFocus, true);
    }

    trapFocus(e) {
        if (this.skipFocusTrap) {
            this.skipFocusTrap = false;
            return;
        }
        const readerApp = document.getElementById('reader-app');
        if (readerApp != null && document.getElementById('reader-app').contains(e.target)) {
            if (e.target.id === "tab-guard-north") {
                this.skipFocusTrap = true;
                document.getElementById("tab-guard-south").focus();
            } else if (e.target.id === "tab-guard-south") {
                this.skipFocusTrap = true;
                document.getElementById("tab-guard-north").focus();
            }
        } else {
            this.firstFocus.current.focus();
        }
    }

    toggleDownloadPdf() {
        if (this.props.downloadPdfExpanded) {
            document.body.style.overflow = null;
        }
        else {
            document.body.style.overflow = 'hidden';
        }
        this.props.toggleDownloadPdf();
    }

    downloadPdf() {
        this.props.showPdfProgress();

        var hasGenerated = false;
        var timerHit = false;
        var blob;

        fetch(this.props.reader.downloadUrl, { method: 'GET' })
            .then(response => response.blob())
            .then(data => {
                hasGenerated = true;
                blob = new Blob([data], { type: "application/pdf" });
                this.triggerDownload(blob, hasGenerated, timerHit);
            });

        setTimeout(() => {
            timerHit = true;
            this.triggerDownload(blob, hasGenerated, timerHit);
        }, 1000);
    }

    // Will trigger download when both timer and fetch is ready.
    triggerDownload(blob, hasGenerated, timerHit) {
        if (!timerHit || !hasGenerated)
            return;

        FileSaver.saveAs(blob, this.props.reader.filename);
        this.props.hidePdfProgress();
    }

    handleEscKey(e) {
        if (e.key.match(/^esc/i)) {
            this.tooltip.current && this.tooltip.current.hide();
        }
    }

    handleTermClick(e) {
        const termElement = e.target.closest('.defined-term');

        var $ = window.$;

        if (termElement && e.currentTarget.contains(termElement)) {
            const rect = e.target.getBoundingClientRect();
            const term = termElement.innerText;
            const definition = termElement.getAttribute('data-definition');
            this.tooltip.current.show(term, this.cleanDefinition(definition), rect);
        } else {
            this.tooltip.current.hide();
        }
    }

    cleanDefinition(definition) {
        var element = document.createElement('div');
        element.innerHTML = definition;
        return element.innerText;
    }

    render() {
        if (this.props.reader.loading) {
            return (
                <div className="pubr-overlay__loading" style={{ height: (window.innerHeight - 40) + 'px' }}>
                    <span className="pubr-spinner"></span>
                </div>
            );
        }

        var body = this.props.reader.sections.map((section) => {

            var subSections = section.subSections.map((subSection) => {
                return (
                    <div key={subSection.sectionId}>
                        <h3 id={subSection.sectionId} tabIndex="-1">{subSection.sectionHeading}</h3>
                        <div dangerouslySetInnerHTML={{ __html: subSection.sectionText }} />
                    </div>
                )
            });

            return (
                <div key={section.sectionId} lang={section.language}>
                    <h2 id={section.sectionId} tabIndex="-1">{section.sectionHeading}</h2>
                    <div dangerouslySetInnerHTML={{ __html: section.sectionText }} />
                    {subSections}
                </div>
            )
        });

        if (this.props.reader.downloadPdfExpanded) {
            var className = this.state.className + ' pubr-reader--dimmed';
        }
        else {
            className = this.state.className;
        }

        return (
            <div
                id="publication-reader-dialog"
                role="dialog"
                aria-modal="true"
                aria-labelledby="main-heading"
                tabIndex="0"
                className={className}
                ref={this.firstFocus}
            >
                <a id="pubr-skip" href="#main-heading">{this.props.reader.readerGui.guiLang == "sv" ? "Hoppa till innehållet" : "Go to content"}</a>
                {this.props.reader.tableOfContentsExpanded &&
                    <div className="pubr-sidebar">
                        <TableOfContents />
                    </div>
                }
                <div className="pubr-content">
                    {this.props.reader.isClientSide &&
                        <div>
                            <Header
                                scrollPosition={this.props.reader.scrollPosition}
                                toggleTableOfContents={this.props.toggleTableOfContents}
                                tableOfContentsExpanded={this.props.reader.tableOfContentsExpanded}
                                toggleDownloadDialog={this.props.toggleDownloadDialog.bind(this)}
                                toggleDownloadDialogFull={this.props.toggleDownloadDialogFull.bind(this)}
                                downloadPdf={this.downloadPdf.bind(this)}
                                title={this.props.reader.title} />
                            <DownloadDialog toggleDownloadDialog={this.props.toggleDownloadDialog.bind(this)} />
                            <SkipButton buttonText={this.props.reader.readerGui.jumpToLatestText} />
                        </div>
                    }
                    {this.props.reader.isClientSide &&
                        <Progress sections={this.props.reader.sections} />
                    }
                    <main className="pubr-main" lang={this.props.reader.readerGui.publicationLang}>
                        <img src="/static/images/logo.png" className="pubr-main__logo" alt="SBU" />
                        <h1 id="main-heading" className="pubr-main__heading">{this.props.reader.title}</h1>
                        <p className="pubr-main__subtitle">{this.props.reader.titleSubTitle}</p>
                        <p className="pubr-main__introduction">{this.props.reader.subTitle}</p>
                        <MetaData
                            pubDate={this.props.reader.pubDate}
                            updatedDate={this.props.reader.updatedDate}
                            pubNumber={this.props.reader.pubNumber}
                            pubType={this.props.reader.pubType}
                            readerGui={this.props.reader.readerGui}
                        />
                        <div
                            className="pubr-main__body"
                            onClick={this.handleTermClick}
                        >
                            {this.props.reader.isClientSide}
                            {body}
                        </div>
                    </main>
                </div>
                <Tooltip ref={this.tooltip} />
            </div>
        );
    }
}

module.exports = Main;



// WEBPACK FOOTER //
// ./src/modules/reader/components/Main.js